import React from "react";
import { withI18n } from "react-i18next";
import styled from "styled-components";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { client } from "../../../shared/apiClient";
import Header from "../../Common/Header";
import { Button, ButtonGroup, Toggle, Typography } from "../../Common";
import { iRootState } from "../../../store";
import {
  IAuditionsDto,
  IFailedEmailsList,
} from "../../../shared/dto/IKioskDto";
import KioskSessionAuditionsRow from "./KioskSessionAuditionsRow";
import EditPen from "../../../images/pen-edit-blue.svg";

// @ts-ignore
import { moment } from "cwb-react";
import AlertMessage from "../../Modals/AlertMessage";
import { IVideoDirection } from "../../../interfaces/IVideoDirections";

// @ts-ignore
import { CWBTableRowProps } from "cwb-react";
import {
  isTodayAudition,
  isPastAudition,
  isTodayOrFutureAudition,
  getEncodeParams,
} from "../../../helpers";
import { IKioskSessionInfo } from "../../../interfaces/IKioskSessionInfo";
import { IKioskSessionAuditionsDto } from "../../../interfaces/IKioskSessionAuditionsDto";
import FailedEmailDetailsModal from "../../Modals/FailedEmailDetailsModal";
import ResendAuditionLinkModal from "../../Modals/ResendAuditionLinkModal";
import InfoSheetsEnabledModal from "../../Modals/InfoSheetsEnabledModal";
import SessionMaterial from "./SessionMaterial";
import MaterialsIcon from "../../../images/folder.svg";
import CheckGreen from "../../../images/check-green.svg";
import { ISentSessionMaterial } from "../../../interfaces/ISentSessionMaterial";
import AlertButtonIcon from "../../Common/AlertButtonIcon";
import SendAuditionTimeUpdateModal from "../../Modals/SendAuditionTimeUpdateModal";
import AlertModal from "../../Modals/AlertModal";
import RowLoadingPlaceholder from "./RowLoadingPlaceholder";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import UpdateOrderNumberModal from "../../Modals/UpdateOrderNumberModal";

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t?: any;
  match: any;
}

class KioskSessionAuditions extends React.Component<IProps, {}> {
  state = {
    auditionsDetails: [] as IAuditionsDto[],
    isLoading: false,
    showSendMaterial: false,
    showSendAuditionTimeUpdateModal: false,
    showWarningBeforeUnload: false,
    showUpdateOrderNumberModal: false,
    isRowDragged: false,
    hasDismissedSendAuditionTimeUpdate: false,
  };

  async componentWillMount() {
    this.setState({ isLoading: true });
    try {
      const scheduleId = this.props.match.params.id;
      await this.props.getKioskSessionInfo(scheduleId);

      await this.loadSessionAuditions(scheduleId, true);

      if (
        this.props.sessionAuditions &&
        this.props.sessionAuditions.epitchId > 0
      )
        await this.props.getSentSessionMaterials(
          this.props.sessionAuditions.epitchId
        );
    } catch (error) {
      this.props.history.push("/500");
    }
    this.setState({ isLoading: false });
    window.addEventListener("beforeunload", this.handleUnload);
  }

  componentWillUnmount() {
    this.props.setKioskSessionAuditions(null);
    window.removeEventListener("beforeunload", this.handleUnload);
  }

  loadSessionAuditions = async (scheduleId: any, reorder = false) => {
    if (!scheduleId) return;
    this.setState({ isLoading: true });
    await this.props.getSessionAuditionsOptReorder({ scheduleId, reorder });

    await this.props.getVideoDirections(scheduleId);

    const { videoDirections, sessionAuditions } = this.props;

    let auditionsDetails = sessionAuditions.auditionsDetails.map(
      (audDto: IAuditionsDto) => {
        const vd = videoDirections.find((x) => x.roleId === audDto.roleId);
        if (vd) {
          audDto.videoDirection = vd;
        }
        return audDto;
      }
    );
    this.setState({ auditionsDetails });
    this.setState({ isLoading: false });
  };

  handleUnload = (e: any) => {
    // e.preventDefault();
    if (
      this.hasAnyAuditionUpdatedTime() &&
      !this.state.hasDismissedSendAuditionTimeUpdate &&
      this.isVcr()
    ) {
      this.showAlertBeforeUnload();
      var message = "";
      (e || window.event).returnValue = message; // IE
      return message;
    }
  };

  onDragEnd = async (result: any) => {
    // dropped outside the list
    if (
      !result.destination ||
      result.destination.index === result.source.index
    ) {
      return;
    }

    // no movement
    if (result.destination.index === result.source.index) {
      return;
    }

    await this.handleDragAndDropChanges(result);
  };

  /** Same group/RoleId Swap - for later... need more logic than simply comparing roleId and time? **/
  // must be a grp schedule? same roleId and many with same time, but not all or one
  isGroupSwap = (
    draggedItem: IAuditionsDto,
    replacedItem: IAuditionsDto
  ): boolean => {
    if (
      draggedItem.roleId !== replacedItem.roleId ||
      draggedItem.auditionTime === replacedItem.auditionTime
    )
      return false;

    const { sessionAuditions } = this.props;

    if (!sessionAuditions || !sessionAuditions.auditionsDetails) return false;

    let auditionsDetails = sessionAuditions.auditionsDetails;

    let draggedAuditionGroup = auditionsDetails.filter(
      (x) => x.roleId == draggedItem.roleId
    );
    if (draggedAuditionGroup.length <= 1) return false;
    if (
      !draggedAuditionGroup.every(
        (x) => x.auditionTime == draggedItem.auditionTime
      )
    )
      return false;

    let replacedAuditionGroup = auditionsDetails.filter(
      (x) => x.roleId == replacedItem.roleId
    );
    if (replacedAuditionGroup.length <= 1) return false;
    if (
      !replacedAuditionGroup.every(
        (x) => x.auditionTime == replacedItem.auditionTime
      )
    )
      return false;

    return true;
  };

  handleDragAndDropChanges = async (result: any) => {
    this.setState({ isLoading: true });
    const { sessionAuditions } = this.props;

    if (!sessionAuditions || !sessionAuditions.auditionsDetails) return;

    let auditionsDetails = sessionAuditions.auditionsDetails;

    const auditionsAreAllOnSameTime = auditionsDetails.every(
      (x) => x.auditionTime === auditionsDetails[0].auditionTime
    );

    const isSwaped =
      result.destination.index == result.source.index + 1 ||
      result.destination.index == result.source.index - 1;

    let draggedItem = auditionsDetails[result.source.index];
    let pushedItem = auditionsDetails[result.destination.index];

    if (isSwaped) {
      await this.swapAudition(draggedItem, pushedItem);
      this.setState({ isLoading: false });
      return;
    }

    if (!isSwaped && !auditionsAreAllOnSameTime) {
      await this.moveAuditionDiffTime(draggedItem, pushedItem);
      this.setState({ isLoading: false });
      return;
    }

    if (!isSwaped && auditionsAreAllOnSameTime) {
      const isDraggedUp =
        result.destination.index < result.source.index ? true : false;
      await this.moveAuditionSameTime(draggedItem, pushedItem, isDraggedUp);
      this.setState({ isLoading: false });
      return;
    }
  };

  moveAuditionDiffTime = async (
    draggedItem: IAuditionsDto,
    replacedItem: IAuditionsDto
  ) => {
    await this.props.patchMoveAuditionTime({
      draggeddAudSchedId: draggedItem.auditionScheduleId,
      pushedAudSchedId: replacedItem.auditionScheduleId,
    });
    // reload (reorder set to false here, done internally by the API)
    await this.loadSessionAuditions(draggedItem.scheduleId, false);
  };

  swapAudition = async (
    draggedItem: IAuditionsDto,
    replacedItem: IAuditionsDto
  ) => {
    await this.props.patchAuditionSwap({
      draggeddAudSchedId: draggedItem.auditionScheduleId,
      pushedAudSchedId: replacedItem.auditionScheduleId,
    });
    // reload (reorder set to false here, done internally by the API)
    await this.loadSessionAuditions(draggedItem.scheduleId, false);
  };

  moveAuditionSameTime = async (
    draggedItem: IAuditionsDto,
    replacedItem: IAuditionsDto,
    isDraggedUp: boolean
  ) => {
    await this.props.patchMoveAuditionOrder({
      draggeddAudSchedId: draggedItem.auditionScheduleId,
      pushedAudSchedId: replacedItem.auditionScheduleId,
      isDraggedUp,
    });
    // reload (reorder set to false here, done internally by the API)
    await this.loadSessionAuditions(draggedItem.scheduleId, false);
  };

  getZoomLink = () => {
    const { sessionAuditions } = this.props;

    if (!sessionAuditions) return null;

    let pastAudition = false;
    if (
      sessionAuditions.auditionsDetails &&
      sessionAuditions.auditionsDetails.length > 0
    ) {
      pastAudition =
        isPastAudition(
          sessionAuditions.auditionsDetails[
            sessionAuditions.auditionsDetails.length - 1
          ].auditionTime,
          sessionAuditions.auditionDate
        ) && !isTodayAudition(sessionAuditions.auditionDate);
    }

    if (!pastAudition) {
      return sessionAuditions.virtualURL;
    }

    return null;
  };

  onClickSendSessionMaterial = () => {
    this.setState({ showSendMaterial: true });
  };

  onCancelSendSessionMaterial = () => {
    this.setState({ showSendMaterial: false });
  };

  getViewMaterialLink = () => {
    const { sessionAuditions, match } = this.props;

    const scheduleId = match.params.id;

    if (sessionAuditions && sessionAuditions.epitchId > 0) {
      return `${client.api.paths.domain}/castingworkbook/cwbfw/#/epitch/preview/${sessionAuditions.epitchId}`;
    }

    const title = `${sessionAuditions.projectName} - ${sessionAuditions.sessionName}`;
    const params = {
      scheduleId: scheduleId,
      title: title,
    };
    const url = `${
      client.api.paths.epitch
    }/Manage/ViewMaterial/?${getEncodeParams(params)}`;

    return url;
  };

  hasAnyAuditionUpdatedTime = () => {
    if (this.state.auditionsDetails.length === 0) return false;
    return this.state.auditionsDetails.some((x) => x.isAuditionTimeUpdated);
  };

  updateAuditionsStartOrder = async (audStartNumber: any) => {
    const scheduleId = this.props.match.params.id;
    await this.props.updateAuditionsStartOrder({ scheduleId, audStartNumber });
    await this.loadSessionAuditions(scheduleId, true);
  };

  showModalSendAuditionTimeUpdate = () => {
    this.setState({
      showSendAuditionTimeUpdateModal: true,
    });
  };

  hideModalSendAuditionTimeUpdate = () => {
    this.setState({
      showSendAuditionTimeUpdateModal: false,
    });
  };

  onCloseSendAuditionTimeUpdate = () => {
    this.setState({ hasDismissedSendAuditionTimeUpdate: true });
  };

  showAlertBeforeUnload = () => {
    this.setState({
      showWarningBeforeUnload: true,
    });
  };
  hideAlertBeforeUnload = () => {
    this.setState({
      showWarningBeforeUnload: false,
    });
  };

  onSendAlertBeforeUnload = () => {
    this.setState({
      showWarningBeforeUnload: false,
    });
    this.showModalSendAuditionTimeUpdate();
  };

  toggleUpdateOrderNumberModal = () => {
    this.setState({
      showUpdateOrderNumberModal: !this.state.showUpdateOrderNumberModal,
    });
  };

  loadingPlaceholderFiller = () => {
    if (
      this.props.sessionAuditions &&
      this.props.sessionAuditions.auditionsDetails
    ) {
      return new Array(
        this.props.sessionAuditions.auditionsDetails.length
      ).fill({});
    }
    return new Array(5).fill({});
  };

  isVcr = () => {
    const { sessionAuditions } = this.props;
    return (
      sessionAuditions &&
      sessionAuditions.virtualURL &&
      sessionAuditions.virtualURL.length > 0
    );
  };

  render() {
    const { sessionAuditions, t, match } = this.props;

    const scheduleId = match.params.id;

    const infoSheetsEnabled = this.props.sessionInfo.infoSheetsEnabled;

    let isTodayOrFuture = false;
    if (sessionAuditions && sessionAuditions.auditionDate)
      isTodayOrFuture = isTodayOrFutureAudition(sessionAuditions.auditionDate);

    if (!sessionAuditions) {
      return <AlertMessage {...this.props} />;
    }

    const breadCrumbList = [
      {
        label: t("Scheduling"),
        to: `${client.api.paths.domain}/castingworkbook/directors/schedulelist.asp`,
      },
      { label: t("Casting Kiosk"), to: "/", relative: true },
      {
        label: `${sessionAuditions.projectName} ${sessionAuditions.sessionName}`,
      },
    ];

    const handleEnableInfoSheet = (checked: boolean) => {
      if (checked) {
        this.props.setShowInfoSheetsEnabledModal(true);
      }
      this.props.setInfoSheetsEnabled({
        scheduleId,
        enabled: checked,
      });
    };

    const bdType = this.props.sessionAuditions.bdType;

    let headers = [
      { label: " " },
      {
        label: (
          <span key="audOrder">
            {t("Order")}
            {isTodayOrFuture && (
              <StyledEditPenIcon
                src={EditPen}
                onClick={this.toggleUpdateOrderNumberModal}
              />
            )}
          </span>
        ),
      },
      { label: t("Audition Time") },
      { label: t("Actor") },
      { label: bdType === 2 ? t("Spot/Role") : t("Role") },
      {
        label: (
          <div>
            <span key="info-sheet">
              {t("Info Sheet")}
              <StyledToggle
                checked={infoSheetsEnabled}
                label={infoSheetsEnabled ? t("enabled") : t("disabled")}
                onChange={(e) => handleEnableInfoSheet(e.target.checked)}
              />
            </span>
          </div>
        ),
      },
      { label: t("Check-in") },
      { label: t("Checkout") },
      { label: "" },
    ];

    let zeroAuditionsHeaders = [
      { label: " " },
      {
        label: <span key="audOrder">{t("Order")}</span>,
      },
      { label: t("Audition Time") },
      { label: t("Actor") },
      { label: bdType === 2 ? t("Spot/Role") : t("Role") },
      { label: t("Info Sheet") },
      { label: t("Check-in") },
      { label: t("Checkout") },
      { label: "" },
    ];

    let placeholderHeaders = [{ label: "" }];
    const zoomLink = this.getZoomLink();

    const alertMsgSendUpdate = t(
      "Changes have been made to the schedule that have not been sent to the actors. To update the effected actors please resend the audition link."
    );

    const alertMsgWarningBeforeUnload = (
      <span>
        <b>{t("Warning")}: </b>
        {t(
          "you have not notified actors and agents of the updates made to the schedule. If you do not send the update the actors will not have access to their new times."
        )}
      </span>
    );

    return (
      <Wrapper>
        {this.state.showSendAuditionTimeUpdateModal && (
          <SendAuditionTimeUpdateModal
            hideModal={this.hideModalSendAuditionTimeUpdate}
            scheduleId={scheduleId}
            loadSessionAuditions={this.loadSessionAuditions}
          />
        )}
        {this.state.showUpdateOrderNumberModal && (
          <UpdateOrderNumberModal
            hideModal={this.toggleUpdateOrderNumberModal}
            updateAuditionsStartOrder={this.updateAuditionsStartOrder}
          />
        )}
        {this.state.showSendMaterial && (
          <SessionMaterial
            scheduleId={scheduleId}
            epitchId={sessionAuditions.epitchId}
            showModal={this.state.showSendMaterial}
            onCancel={this.onCancelSendSessionMaterial}
          />
        )}
        <AlertMessage {...this.props} />
        {this.state.showWarningBeforeUnload && (
          <AlertModal
            message={alertMsgWarningBeforeUnload}
            cancelBtnMsg={t("Not now")}
            actionBtnMsg={t("Send Updates")}
            closeModal={this.hideAlertBeforeUnload}
            actionBtn={this.onSendAlertBeforeUnload}
          />
        )}
        {this.props.showFailedEmailModal && (
          <FailedEmailDetailsModal
            failedEmailsList={this.props.failedEmailsList}
            showModal={this.props.showFailedEmailModal}
            togglePopover={() => this.props.setShowFailedEmailModal(false)}
          />
        )}
        {this.props.showResendLinkModal && <ResendAuditionLinkModal />}
        {this.props.showInfoSheetsEnabledModal && <InfoSheetsEnabledModal />}
        <Header
          title={`${sessionAuditions.projectName} ${sessionAuditions.sessionName}`}
          breadCrumbList={breadCrumbList}
        ></Header>
        <ContentBox>
          {this.hasAnyAuditionUpdatedTime() && this.isVcr() && (
            <AlertButtonIcon
              message={alertMsgSendUpdate}
              color="warning"
              btnTxt={t("Send updates")}
              btnOnClick={this.showModalSendAuditionTimeUpdate}
              onClose={this.onCloseSendAuditionTimeUpdate}
            />
          )}
          <ContentHeader>
            <ContentTitle>
              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography component="h2" variant="h5">
                  {moment.moment(sessionAuditions.auditionDate).format("LL")}
                </Typography>
                {this.state.auditionsDetails &&
                  this.state.auditionsDetails.length > 0 && (
                    <span>
                      <StyledImgIcon src={MaterialsIcon} />
                      <StyledLink
                        href={this.getViewMaterialLink()}
                        target="_blank"
                      >
                        {t("View Materials")}
                      </StyledLink>
                    </span>
                  )}
                <a
                  href={`${client.api.paths.domain}/castingworkbook/directors/printSessionInfoSheets.asp?sid=${scheduleId}`}
                  className="print-all"
                >
                  <i className="icon-cwb-print-new"></i> {t("Print All")}
                </a>
              </div>
              <div>
                <StyledButtonGroup direction="row-reverse">
                  {zoomLink && isTodayOrFuture && (
                    <Button>
                      <StyledWhiteLink href={zoomLink} target="_blank">
                        {t("Open Virtual Room")}
                      </StyledWhiteLink>
                    </Button>
                  )}
                  {isTodayOrFuture &&
                    this.state.auditionsDetails &&
                    this.state.auditionsDetails.length > 0 && (
                      <Button
                        startIcon={
                          this.props.sentSessionMaterials &&
                          this.props.sentSessionMaterials.length > 0 && (
                            <StyledSentImgIcon src={CheckGreen} />
                          )
                        }
                        variant="secondary"
                        onClick={this.onClickSendSessionMaterial}
                      >
                        {t("Send Materials")}
                      </Button>
                    )}
                  {zoomLink && (
                    <Button
                      variant="secondary"
                      onClick={() =>
                        this.props.setShowResendLinkModal(true, scheduleId)
                      }
                    >
                      {t("Resend Audition Link")}
                    </Button>
                  )}
                </StyledButtonGroup>
              </div>
            </ContentTitle>
          </ContentHeader>
          {this.state.isLoading ||
          !this.state.auditionsDetails ||
          !this.state.auditionsDetails.length ? (
            <StyledCwbTable
              rowComponent={RowLoadingPlaceholder}
              rows={this.loadingPlaceholderFiller()}
              headers={
                !this.state.isLoading &&
                this.state.auditionsDetails.length === 0
                  ? zeroAuditionsHeaders
                  : placeholderHeaders
              }
              rowProps={{}}
            />
          ) : (
            <DragDropContext onDragEnd={this.onDragEnd}>
              <StyledTable>
                {headers && (
                  <thead>
                    <tr>
                      {headers.map((header, index) => {
                        return (
                          <th
                            key={`header_${index}`}
                            id={`ts_table_header_${index}`}
                          >
                            {header.label}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                )}
                <Droppable
                  droppableId="table"
                  isDropDisabled={!isTodayOrFuture}
                >
                  {(droppableProvided) => (
                    <tbody
                      ref={(ref) => {
                        droppableProvided.innerRef(ref);
                      }}
                      {...droppableProvided.droppableProps}
                    >
                      {this.state.auditionsDetails.map((row, index) => (
                        <Draggable
                          draggableId={row.auditionScheduleId.toString()}
                          index={index}
                          key={row.auditionScheduleId}
                          isDragDisabled={!isTodayOrFuture}
                        >
                          {(provided, snapshot) => (
                            <KioskSessionAuditionsRow
                              row={row}
                              provided={provided}
                              snapshot={snapshot}
                            />
                          )}
                        </Draggable>
                      ))}
                      {droppableProvided.placeholder}
                    </tbody>
                  )}
                </Droppable>
              </StyledTable>
            </DragDropContext>
          )}
        </ContentBox>
      </Wrapper>
    );
  }
}

interface StateProps {
  sessionAuditions: IKioskSessionAuditionsDto;
  videoDirections: IVideoDirection[];
  sentSessionMaterials: ISentSessionMaterial[];
  showFailedEmailModal: boolean;
  failedEmailsList: IFailedEmailsList[];
  showResendLinkModal: boolean;
  sessionInfo: IKioskSessionInfo;
  showInfoSheetsEnabledModal: boolean;
}

function mapStateToProps(state: iRootState): StateProps {
  return {
    sessionAuditions: state.kiosk.sessionAuditions,
    videoDirections: state.kiosk.videoDirections,
    sentSessionMaterials: state.sentSessionMaterial.sentSessionMaterials,
    showFailedEmailModal: state.kiosk.showFailedEmailModal,
    failedEmailsList: state.kiosk.failedEmailsList,
    showResendLinkModal: state.kiosk.showResendLinkModal.show,
    sessionInfo: state.kiosk.sessionInfo,
    showInfoSheetsEnabledModal: state.kiosk.showInfoSheetsEnabledModal,
  };
}

interface DispatchProps {
  getKioskSessionInfo: (id: string) => void;
  getSessionAuditionsOptReorder: ({ scheduleId, reorder }: any) => void;
  setInfoSheetsEnabled: (payload: {
    scheduleId: number;
    enabled: boolean;
  }) => void;
  setKioskSessionAuditions: (
    sessionAuditions: IKioskSessionAuditionsDto
  ) => void;
  getVideoDirections: (id: string) => void;
  getSentSessionMaterials: (id: any) => void;
  setShowFailedEmailModal: (show: boolean) => any;
  setShowResendLinkModal: (show: boolean, scheduleId?: number) => any;
  setShowInfoSheetsEnabledModal: (show: boolean) => any;
  patchAuditionSwap: ({ auditionScheduleId, pushedAudSchedId }: any) => void;
  patchMoveAuditionTime: ({
    draggeddAudSchedId,
    pushedAudSchedId,
  }: any) => void;
  patchMoveAuditionOrder: ({
    draggeddAudSchedId,
    pushedAudSchedId,
    isDraggedUp,
  }: any) => void;
  updateAuditionsStartOrder: ({ scheduleId, audStartNumber }: any) => void;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    getKioskSessionInfo: dispatch.kiosk.getKioskSessionInfo,
    getSessionAuditionsOptReorder: dispatch.kiosk.getSessionAuditionsOptReorder,
    setInfoSheetsEnabled: dispatch.kiosk.setInfoSheetsEnabled,
    setKioskSessionAuditions: dispatch.kiosk.setKioskSessionAuditions,
    getVideoDirections: dispatch.kiosk.getVideoDirections,
    getSentSessionMaterials:
      dispatch.sentSessionMaterial.getSentSessionMaterials,
    setShowFailedEmailModal: dispatch.kiosk.setShowFailedEmailModal,
    setShowResendLinkModal: dispatch.kiosk.setShowResendLinkModal,
    setShowInfoSheetsEnabledModal: dispatch.kiosk.setShowInfoSheetsEnabledModal,
    patchAuditionSwap: dispatch.auditions.patchAuditionSwap,
    patchMoveAuditionTime: dispatch.auditions.patchMoveAuditionTime,
    patchMoveAuditionOrder: dispatch.auditions.patchMoveAuditionOrder,
    updateAuditionsStartOrder: dispatch.auditions.updateAuditionsStartOrder,
  };
}

export default withI18n()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(KioskSessionAuditions))
);

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: ${(p) => p.theme.kiosk.backgroundColor};

  .cwb-table-wrapper {
    max-width: 1040px;
    border: 1px solid #e7e7f0 !important;
    box-shadow: 0 2px 4px 0 #e0e0e0 !important;
    border-radius: 4px;
  }
`;

const StyledLink = styled.a`
  margin-right: 16px;
  font-size: 14px;
  &&&,
  &:hover {
    color: ${(p) => p.theme.grey};
    font-weight: normal;
    text-decoration: underline;
  }
`;

const ContentBox = styled.div`
  width: 100%;
  min-height: 70vh;
  max-width: 1440px;
  display: flex;
  flex-direction: column;
  margin: 40px auto;
  padding: ${(p) => p.theme.spacing(0, 6)};
  overflow-x: auto;
  overflow-y: hidden;

  & div.cwb-table-wrapper {
    max-width: 1440px;
  }
`;

const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  margin-right: 2px;
`;

const ContentTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  color: ${(p) => p.theme.formField.color};
  font-size: ${(p) => p.theme["lg-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  line-height: 22px;

  .print-all {
    float: right;
    margin-top: 1px;
    color: ${(p) => p.theme.formField.color} !important;
    text-decoration: none;
    i:before {
      font-size: 12px;
    }
    font-size: ${(p) => p.theme["xs-font-size"]};
    font-weight: ${(p) => p.theme["font-weight-600"]};
    cursor: pointer;
  }
`;

const StyledCwbTable = styled(CWBTableRowProps)`
  background: white;
  box-shadow: none !important;

  thead {
    border-radius: 3px 3px 0 0;
    box-shadow: inset 0 -1px 0 0 #e7e7f0;

    tr {
      border: 0;
      th {
        height: 50px;
        background-color: #f8f8f8;
        > div {
          display: flex;
          color: ${(p) => p.theme.grey};
          font-size: ${(p) => p.theme["s-font-size"]};
          font-weight: ${(p) => p.theme["font-weight-600"]};
          text-transform: initial;
          line-height: 19px;

          & > span {
            display: flex;
            align-items: center;
          }
        }
        &:first-child {
          padding-left: 24px;
        }
        .icon-cwb-chevron:before {
          color: ${(p) => p.theme.grey} !important;
        }
      }
    }
  }
`;

const StyledTable = styled.table`
  width: 100%;
  background: white;
  border: none;
  border-radius: 4px;
  border: 1px solid rgb(231, 231, 240) !important;
  box-shadow: rgb(224, 224, 224) 0px 2px 4px 0px !important;
  tr {
    border: 0;

    height: 48px;
    border-bottom: 1px solid rgb(222, 226, 230);
    box-shadow: rgb(231, 231, 240) 0px -1px 0px 0px inset;

    &.deleted * {
      text-decoration: line-through;
    }

    td {
      border: 0;
      height: 48px;
      color: ${(p) => p.theme.grey};
      font-size: ${(p) => p.theme["font-size"]};
    }

    i {
      color: ${(p) => p.theme.grey};
      &.blue {
        color: ${(p) => p.theme.lightBlue};
      }
      &.grey {
        color: ${(p) => p.theme.kiosk.bdColor};
      }
      &.pink {
        color: ${(p) => p.theme.kiosk.pink};
      }
      &.disabled {
        color: ${(p) => p.theme["disabled-grey"]};
        cursor: default;
      }
    }
  }

  td {
    &:last-child {
      border-right: 0;
    }
    &:first-child {
      text-align: left;
      padding-left: 32px;
    }
  }

  td.first-col {
    font-size: 13px;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    color: #161616;
    white-space: normal;
    position: relative;
    img {
      display: none;
      height: 16px;
      width: 16px;
      position: absolute;
      left: 8px;
      top: 23px;
      display: inline-flex;
    }
  }

  thead {
    border-radius: 3px 3px 0 0;
    box-shadow: inset 0 -1px 0 0 #e7e7f0;

    tr {
      border: 0;
      th {
        vertical-align: middle;
        border-bottom: 1px solid rgb(222, 226, 230);
        padding: 0px 16px 0px 0px;
        margin: 0px;
        line-height: 36px;
        border-top-color: rgb(222, 226, 230);
        border-right-color: rgb(222, 226, 230);
        border-left-color: rgb(222, 226, 230);
        height: 52px;

        background-color: #f8f8f8;

        text-transform: none;
        color: #0a1f44;
        font-size: 13px;
        font-weight: 600;
        line-height: 18px;
        border-color: #e9eded;

        > div {
          display: flex;
          color: ${(p) => p.theme.grey};
          font-size: ${(p) => p.theme["s-font-size"]};
          font-weight: ${(p) => p.theme["font-weight-600"]};
          text-transform: initial;
          line-height: 19px;

          & > span {
            display: flex;
            align-items: center;
          }
        }
        &:first-child {
          padding-left: 24px;
        }
        .icon-cwb-chevron:before {
          color: ${(p) => p.theme.grey} !important;
        }
      }
    }
  }
`;

const StyledWhiteLink = styled.a`
  color: white !important;
  &&&& {
    font-weight: bold;
  }
  font-size: 14px;
  text-decoration: none !important;
  &&&,
  &:hover {
    color: ${(p) => p.theme.grey};
    font-weight: normal;
    text-decoration: underline;
  }
`;

const StyledImgIcon = styled.img`
  margin-right: 5px;
  padding-bottom: 0px;
  width: 16px;
  margin-left: 12px;
`;

const StyledSentImgIcon = styled.img`
  margin-right: 14px;
  padding-bottom: 4px;
  width: 16px;
`;

const StyledButtonGroup = styled(ButtonGroup)`
  height: 36px;
`;

const StyledToggle = styled(Toggle)`
  display: inline-flex;

  & > div {
    transform: scale(0.6);
  }
  & > label {
    color: #353b48;
    font-weight: normal;
    margin: ${(p) => p.theme.spacing("-1px", 0, 0)};
    text-transform: none;
  }
`;

const StyledEditPenIcon = styled.img`
  padding: 0px 0px 3px 5px;
  cursor: pointer;
`;
